export function isImageOrVideo(input) {
  const imageTypes = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/bmp",
    "image/webp",
    "image/tiff",
    "image/svg+xml",
    "image/x-icon",
  ];

  const videoTypes = [
    "video/mp4",
    "video/ogg",
    "video/webm",
    "video/avi",
    "video/mpeg",
    "video/quicktime",
    "video/x-ms-wmv",
    "video/x-flv",
    "video/3gpp",
  ];

  const imageExtensions = [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "bmp",
    "webp",
    "tiff",
    "svg",
    "ico",
  ];

  const videoExtensions = [
    "mp4",
    "ogg",
    "webm",
    "avi",
    "mpeg",
    "mov",
    "wmv",
    "flv",
    "3gp",
  ];

  if (typeof input === "object" && input.type) {
    // Input is a file object
    if (imageTypes.includes(input.type)) {
      return "image";
    } else if (videoTypes.includes(input.type)) {
      return "video";
    } else {
      return "unknown";
    }
  } else if (typeof input === "string") {
    // Input is a URL
    const urlExtension = input.split(".").pop().toLowerCase();
    if (imageExtensions.includes(urlExtension)) {
      return "image";
    } else if (videoExtensions.includes(urlExtension)) {
      return "video";
    } else {
      return "unknown";
    }
  } else {
    return "unknown";
  }
}
